import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface TaskNotesModel {
	title:string;
    note:string;
}

@Component({  
    selector: 'task-notes',
    templateUrl: './task-notes.html',
    styleUrls: ['./task-notes.scss']
})

export class TaskNotesComponent extends DialogComponent<TaskNotesModel, any> implements TaskNotesModel, OnInit {
  	title:string;
    note:string;

  	constructor(
        dialogService: DialogService
    ) {
    	super(dialogService);
  	}

    ngOnInit() {
        
    }
}


// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/modals/task-notes/task-notes.component.ts